<template>
 <ul class="menu-wrapper" v-if="router" :class="{'show-sep':showSeparator}">
    <menu-item :key="index" v-for="(item, index) in router.children" :menuItem="item">
        <!-- 列表项 -->
        <slot slot="sub">
            <menu-lst :router="item"></menu-lst>
        </slot>
    </menu-item>      
 </ul>
</template>
 
<script>
 import MenuItem from "./menu-item";
 import {getURLWithContext, getDynamicURLWithContext, getDynamicURLWithContextNew} from '@/util/util'
 export default {
    name: 'menu-lst',
    components: {
        'menu-item': MenuItem, 
    },
    props: {
        router: {
            type: Object,
        },
        isExpand: {
            type: Boolean,
        },
        showSeparator: {
            type: Boolean,
            default: true
        }
    },
 }
 </script>
 
 <style lang="scss" scoped>
    .menu-wrapper {
        border-radius: .03rem;
        line-height: 3;

		li > ul {
            overflow: hidden;
            transition: all .3s;
        }
    }
    .show-sep {
        li:not(:last-child) {
            border-bottom: solid 2px #d1d1d1;
        }
    }
 </style>


// WEBPACK FOOTER //
// src/components/header/droplist/index.vue